export const bulkJournalEn = {
  "books.bulkPost.title": "Bulk journal posting",
  "books.bulkPost.selectPage": "Select eligible drafts on this page",
  "books.bulkPost.selectEntry": "Select entry: {{description}}",
  "books.bulkPost.selectAll": "Select all matching drafts",
  "books.bulkPost.action": "Post selected",
  "books.bulkPost.selected": "Selected: {{count}}",
  "books.bulkPost.confirm": "Post this selection to the books? This changes account balances. Selected: {{count}}.",
  "books.bulkPost.progress": "Processed: {{done}} / {{total}}",
  "books.bulkPost.stop": "Stop after current batch",
  "books.bulkPost.result": "Confirmed posted: {{posted}}. Already posted: {{existing}}. Remaining to check: {{remaining}}.",
  "books.bulkPost.overlap": "Imported turnover summaries overlap selected or already posted detail. Choose one accounting basis; do not post a summary and its underlying entries together.",
  "books.bulkPost.changed": "A selected draft changed or is no longer available for posting. Refresh and review the selection.",
  "books.bulkPost.limit": "Select no more than 2,000 drafts per operation. Narrow the filters or select fewer rows.",
  "books.bulkPost.interrupted": "Posting could not finish. Some entries may already be posted. Refresh and review their status before retrying.",
  "books.bulkPost.excludeSummaries": "Exclude turnover summaries from selection",
  "books.bulkPost.entryFailed": "Posting validation failed. Open this entry and review its accounts, date and period status.",
} as const

export const bulkJournalRu: Record<keyof typeof bulkJournalEn, string> = {
  "books.bulkPost.title": "Массовое проведение записей журнала",
  "books.bulkPost.selectPage": "Выбрать доступные для проведения черновики на этой странице",
  "books.bulkPost.selectEntry": "Выбрать запись: {{description}}",
  "books.bulkPost.selectAll": "Выбрать все черновики по фильтру",
  "books.bulkPost.action": "Провести выбранное",
  "books.bulkPost.selected": "Выбрано: {{count}}",
  "books.bulkPost.confirm": "Провести выбранный набор записей? Это изменит остатки по счетам. Выбрано: {{count}}.",
  "books.bulkPost.progress": "Обработано: {{done}} / {{total}}",
  "books.bulkPost.stop": "Остановить после текущей группы",
  "books.bulkPost.result": "Подтверждено проведение: {{posted}}. Уже проведено: {{existing}}. Осталось проверить: {{remaining}}.",
  "books.bulkPost.overlap": "Импортированные сводные обороты пересекаются с выбранными или уже проведёнными подробными записями. Выберите один способ учёта; не проводите сводную запись вместе с операциями, которые она включает.",
  "books.bulkPost.changed": "Выбранный черновик изменён или больше недоступен для проведения. Обновите данные и проверьте выбор.",
  "books.bulkPost.limit": "За одну операцию можно выбрать не более 2 000 черновиков. Уточните фильтры или выберите меньше строк.",
  "books.bulkPost.interrupted": "Не удалось завершить проведение. Часть записей уже могла быть проведена. Обновите данные и проверьте их состояние перед повторной попыткой.",
  "books.bulkPost.excludeSummaries": "Исключить сводные обороты из выбора",
  "books.bulkPost.entryFailed": "Проверка перед проведением не пройдена. Откройте запись и проверьте счета, дату и состояние периода.",
}

export const bulkJournalEt: Record<keyof typeof bulkJournalEn, string> = {
  "books.bulkPost.title": "Päevaraamatu kannete hulgikinnitamine",
  "books.bulkPost.selectPage": "Vali selle lehe kinnitamiseks sobivad mustandid",
  "books.bulkPost.selectEntry": "Vali kanne: {{description}}",
  "books.bulkPost.selectAll": "Vali kõik filtrile vastavad mustandid",
  "books.bulkPost.action": "Kinnita valitud",
  "books.bulkPost.selected": "Valitud: {{count}}",
  "books.bulkPost.confirm": "Kinnitada valik? See muudab kontode saldosid. Valitud: {{count}}.",
  "books.bulkPost.progress": "Töödeldud: {{done}} / {{total}}",
  "books.bulkPost.stop": "Peata pärast praegust rühma",
  "books.bulkPost.result": "Kinnitatud: {{posted}}. Juba kinnitatud: {{existing}}. Veel kontrollida: {{remaining}}.",
  "books.bulkPost.overlap": "Imporditud koondkäibed kattuvad valitud või juba kinnitatud üksikkannetega. Vali üks arvestusviis; ära kinnita koondkannet koos sellesse kuuluvate üksikkannetega.",
  "books.bulkPost.changed": "Valitud mustand on muutunud või seda ei saa enam kinnitada. Värskenda andmeid ja kontrolli valikut.",
  "books.bulkPost.limit": "Ühe toiminguga saab valida kuni 2 000 mustandit. Täpsusta filtreid või vali vähem ridu.",
  "books.bulkPost.interrupted": "Kinnitamine jäi pooleli. Osa kandeid võib juba olla kinnitatud. Enne uuesti proovimist värskenda andmeid ja kontrolli nende olekut.",
  "books.bulkPost.excludeSummaries": "Eemalda koondkäibed valikust",
  "books.bulkPost.entryFailed": "Kinnitamise kontroll ebaõnnestus. Ava kanne ning kontrolli kontosid, kuupäeva ja perioodi olekut.",
}

export const journalLifecycleEn = {
  "books.returnToDraft": "Return to draft",
  "books.returnToDraftConfirm": "Return “{{description}}” to draft? This removes its effect from balances until it is posted again. Its posting history will be kept.",
  "books.returnedToDraftSuccess": "Entry returned to draft. Its posting history has been preserved.",
  "books.returnToDraftError": "The entry could not be returned to draft. Refresh its status before retrying.",
  "books.returnedToDraftRevision": "Returned to draft · Revision {{number}}",
  "books.deletedDraftRevision": "Draft deleted · Revision {{number}}",
  "books.returnedToDraftHistoryNotice": "Posting withdrawn. This revision does not contribute to balances.",
  "books.deletedPostedHistoryNotice": "This previously posted entry was deleted as a draft. Its posting and withdrawal history is preserved.",
} as const

export const journalLifecycleRu: Record<keyof typeof journalLifecycleEn, string> = {
  "books.returnToDraft": "Вернуть в черновик",
  "books.returnToDraftConfirm": "Вернуть запись «{{description}}» в черновик? Она перестанет влиять на остатки до повторного проведения. История проведения сохранится.",
  "books.returnedToDraftSuccess": "Запись возвращена в черновик. История её проведения сохранена.",
  "books.returnToDraftError": "Не удалось вернуть запись в черновик. Обновите её состояние перед повторной попыткой.",
  "books.returnedToDraftRevision": "Возврат в черновик · Версия {{number}}",
  "books.deletedDraftRevision": "Черновик удалён · Версия {{number}}",
  "books.returnedToDraftHistoryNotice": "Проведение отменено. Эта версия не влияет на остатки.",
  "books.deletedPostedHistoryNotice": "Ранее проведённая запись была удалена после возврата в черновик. История проведения и его отмены сохранена.",
}

export const journalLifecycleEt: Record<keyof typeof journalLifecycleEn, string> = {
  "books.returnToDraft": "Muuda mustandiks",
  "books.returnToDraftConfirm": "Kas muuta kanne „{{description}}“ uuesti mustandiks? Kanne ei mõjuta saldosid enne uuesti kinnitamist. Kinnitamise ajalugu säilib.",
  "books.returnedToDraftSuccess": "Kanne on muudetud mustandiks. Kinnitamise ajalugu on säilitatud.",
  "books.returnToDraftError": "Kande mustandiks muutmine ebaõnnestus. Enne uuesti proovimist värskenda selle olekut.",
  "books.returnedToDraftRevision": "Muudetud mustandiks · versioon {{number}}",
  "books.deletedDraftRevision": "Mustand kustutatud · versioon {{number}}",
  "books.returnedToDraftHistoryNotice": "Kande kinnitamine on tagasi võetud. See versioon ei mõjuta saldosid.",
  "books.deletedPostedHistoryNotice": "Varem kinnitatud kanne kustutati pärast mustandiks muutmist. Kinnitamise ja mustandiks muutmise ajalugu säilib.",
}

export const booksEn = {
  "books.setup": "Setup",
  "books.search": "Search descriptions, references or accounts…",
  "books.fromDate": "From date", "books.toDate": "To date",
  "books.dateAndSort": "Date and sort",
  "books.sort": "Sort by date", "books.newest": "Newest first", "books.oldest": "Oldest first",
  "books.rowsPerPage": "Rows per page", "books.range": "Showing {{start}}–{{end}} of {{total}}",
  "books.dateRangeError": "The end date must be on or after the start date.",
  "books.postings": "Posting breakdown", "books.sourceInvoice": "Open source invoice",
  "books.sourceError": "Could not load the source invoice.",
  "books.saveAnother": "Save draft and create another",
  "books.saved": "Journal draft saved.", "books.postedSuccess": "Journal entry posted.",
  "books.reversedSuccess": "Reversing entry posted.",
  "books.unsaved": "You have an unsaved journal entry. Continue editing or discard your changes to leave this section.",
  "books.resume": "Continue editing", "books.discard": "Discard changes",
  "books.leaveConfirm": "Discard the unsaved journal entry and leave this page?",
  "books.dateError": "Enter a valid date between {{start}} and {{end}}.",
  "books.descriptionError": "Enter a description.",
  "books.accountError": "Choose an active account.",
  "books.lineAmountError": "Enter one positive amount, in debit or credit, with up to two decimal places.",
  "books.dimensionError": "Choose an active cost center or no center.",
  "books.movement": "Period movement", "books.closing": "Closing balance",
  "books.filteredTotals": "Totals for displayed accounts",
  "books.nav": "Books",
  "books.title": "Accounting books",
  "books.description": "Post balanced entries and inspect the balances behind this period.",
  "books.scope": "Select a company, project and dated period to open the books.",
  "books.accounts": "Chart of accounts",
  "books.accountCode": "Account code",
  "books.accountName": "Account name",
  "books.accountType": "Type",
  "books.addAccount": "Add account",
  "books.activate": "Activate", "books.deactivate": "Deactivate",
  "books.active": "Active", "books.inactive": "Inactive",
  "books.bank": "Bank", "books.cash": "Cash",
  "books.bankIban": "Bank IBAN",
  "books.saveIban": "Save IBAN",
  "books.ibanHelp": "Save the IBAN for this bank account before importing statements.",
  "books.useBank": "Use for bank", "books.useCash": "Use for cash",
  "books.entry": "New journal entry",
  "books.descriptionField": "Description",
  "books.documentNumber": "Document number (optional)",
  "books.date": "Entry date",
  "books.type": "Entry type",
  "books.manual": "Manual",
  "books.opening": "Opening balance",
  "books.account": "Account",
  "books.debit": "Debit",
  "books.credit": "Credit",
  "books.addLine": "Add line",
  "books.removeLine": "Remove line",
  "books.save": "Save draft",
  "books.edit": "Edit draft",
  "books.trialSections": "Trial-balance source sections",
  "books.trialOpeningRange": "Opening balance at the beginning of the source reporting range.",
  "books.trialOpeningBlocked": "The source opening balance is dated {{start}}. It cannot be posted into this shorter accounting period by changing the journal date.",
  "books.trialTurnover": "Turnover for the period",
  "books.trialYtdNotice": "Source activity covers {{start}}–{{end}} (year to date), not just the selected quarter. This review draft cannot be posted into a shorter period.",
  "books.trialClosing": "Closing balance",
  "books.trialControlStatus": "Control only",
  "books.trialClosingNotice": "Source-backed control, not an additional posting. Closing balances equal opening plus turnover; posting them again would double-count.",
  "books.trialClosingDetails": "Show closing balances by account",
  "books.trialClosingTotals": "Printed net total: {{printed}} EUR per side; sum of detailed debit balances: {{detail}} EUR. Parent totals may net child accounts.",
  "books.editPosted": "Edit posted entry",
  "books.voidEntry": "Void posted entry",
  "books.voidConfirm": "Void the posted entry “{{description}}”? Its accounting effect will be removed from current balances and reports. The posting and its versions will remain in History.",
  "books.voided": "Voided",
  "books.voidedRevision": "Version {{number}} — voided",
  "books.voidedHistoryNotice": "This entry has been voided. These amounts are retained as history and no longer affect current balances.",
  "books.voidedSuccess": "Entry voided. Its history is retained.",
  "books.voidError": "Could not void the entry. Refresh it and check whether it has changed, has dependencies, or affects a locked period.",
  "books.entryView": "Entry view",
  "books.activeEntries": "Active entries",
  "books.historyEntries": "History",
  "books.noActiveEntries": "No active entries in this view.",
  "books.noHistoryEntries": "No reversed or voided entries in this view.",
  "books.saveRepost": "Save and repost",
  "books.repostConfirm": "Save these changes and replace the current posting? Balances and live reports will be updated, and the previous version will remain in History.",
  "books.repostedSuccess": "Entry updated and reposted. The previous version is retained in History.",
  "books.repostError": "Could not repost the entry. It may have changed or become locked. Your edits are retained; check the current entry before retrying.",
  "books.postedEditNotice": "The current posting remains in effect until you save and repost. Earlier versions are retained in History.",
  "books.changeReason": "Reason for change (optional)",
  "books.storno": "Storno (negative turnover)",
  "books.stornoHelp": "For storno, enter positive reversed ledger lines. Reports show negative amounts on the opposite debit/credit sides; balances stay the same.",
  "books.stornoTurnover": "Storno: negative turnover is shown on the original debit/credit sides. Review the source before posting.",
  "books.history": "History",
  "books.revision": "Version {{number}}",
  "books.historyError": "Could not load entry history. Try again.",
  "books.reversed": "Reversed",
  "books.createCorrected": "Create corrected entry",
  "books.correctedDraftConfirm": "Create an editable draft from this reversed entry? The original entry and its reversal will remain in history. The new draft must be reviewed and posted separately.",
  "books.correctedDraftCreated": "Corrected draft created. Review it before posting.",
  "books.correctionError": "Could not create a corrected draft. Refresh the entry and check whether a correction already exists.",
  "books.originalEntry": "Original entry",
  "books.viewCorrected": "View corrected entry",
  "books.editLockedHistory": "Editing is unavailable because it would affect a locked or closed accounting period.",
  "books.editDependentAsset": "This entry supports a non-current asset. Use the asset correction workflow.",
  "books.deleteDraft": "Delete draft",
  "books.accountNotRegistered": "Not registered",
  "books.dateReviewRequired": "Draft date {{date}} is outside the selected period ({{start}}–{{end}}). You can save the draft, but must review the source date and accounting period before posting.",
  "books.unresolvedAccounts": "Accounts needing review: {{accounts}}. You can save this draft, but must register or select active accounts before posting.",
  "books.deleteDraftConfirm": "Delete the unposted draft “{{description}}”? It will be removed from the working list. Source evidence and audit history will be retained.",
  "books.deleteDraftError": "Could not delete the draft. Refresh the list and try again.",
  "books.draftDeleted": "Draft deleted.",
  "books.deletedDraft": "Deleted draft",
  "books.cancelEdit": "Cancel editing",
  "books.journals": "Journal entries",
  "books.empty": "No entries in this period yet.",
  "books.draft": "Draft",
  "books.posted": "Posted",
  "books.post": "Post entry",
  "books.reverse": "Reverse entry",
  "books.reversal": "Reversal",
  "books.invoice": "Invoice",
  "books.payment": "Payment", "books.allocation": "Payment allocation",
  "books.allocationReversal": "Allocation correction",
  "books.creditInvoice": "Credit invoice",
  "books.refund": "Credit refund",
  "books.payroll": "Payroll compensation",
  "books.wagePayment": "Wage payment settlement",
  "books.advanceReceipt": "Customer advance received", "books.advanceApplication": "Customer advance applied",
  "books.supplierAdvance": "Supplier advance paid", "books.supplierApplication": "Supplier advance applied",
  "books.advanceRefund": "Advance refunded",
  "books.advanceCorrection": "Customer advance settlement corrected",
  "books.supplierAdvanceCorrection": "Supplier advance settlement corrected",
  "books.assetCapitalization": "Fixed asset capitalization", "books.assetDepreciation": "Fixed asset depreciation",
  "books.assetDisposal": "Fixed asset disposal",
  "books.assetImpairment": "Fixed asset impairment",
  "books.assetDepreciationCorrection": "Fixed asset depreciation correction",
  "books.assetImpairmentReversal": "Fixed asset impairment reversal",
  "books.assetDisposalCorrection": "Fixed asset disposal expense reclassification",
  "books.balances": "Account balances",
  "books.openingDebit": "Opening debit",
  "books.openingCredit": "Opening credit",
  "books.periodDebit": "Period debit",
  "books.periodCredit": "Period credit",
  "books.closingDebit": "Closing debit",
  "books.closingCredit": "Closing credit",
  "books.noBalances": "Post an entry to see account balances.",
  "books.locked": "This period is locked. Entries are read-only.",
  "books.readOnly": "Editing requires project write access and an open period.",
  "books.loadError": "Could not load the accounting books. Try again.",
  "books.saveError": "Could not save. Check the entry and try again.",
  "books.deleteError": "Could not delete the account. Try again.",
  "books.deleteConfirm": "Delete {{name}}?",
  "books.deleteInUse": "This account is used by accounting records or settings. Remove those references or deactivate the account instead.",
  "books.references": "Used in",
  "books.referencesLimited": "More references exist. Review these sources and try again.",
  "books.referencesUnavailable": "Reference details are not available with your current access.",
  "books.referenceUnavailable": "Could not open this reference. Check your access and selected company, project and period.",
  "books.balanceError": "Each line needs one amount, and total debits must equal total credits.",
  "books.reversalConfirm": "Post a reversing entry for this journal?",
  "books.loading": "Loading books…",
  "books.refresh": "Refresh",
  "books.asset": "Asset",
  "books.liability": "Liability",
  "books.equity": "Equity",
  "books.revenue": "Revenue",
  "books.expense": "Expense",
  "books.close.title": "Close readiness",
  "books.close.description": "Review the bookkeeping checks for the selected period.",
  "books.close.disclaimer": "Bookkeeping close readiness only. This is not a statutory or tax assessment and does not lock the period automatically.",
  "books.close.loading": "Loading close readiness…",
  "books.close.loadError": "Could not load close readiness. Try again.",
  "books.close.ready": "Ready for bookkeeping close", "books.close.needsReview": "Needs review",
  "books.close.unknown": "Unknown", "books.close.passed": "Passed",
  "books.close.exception": "Exception", "books.close.notChecked": "Not checked",
  "books.close.informational": "Informational", "books.close.required": "Required checks",
  "books.close.information": "Information", "books.close.otherCheck": "Additional check",
  "books.close.count": "Count", "books.close.exceptions": "Required exceptions",
  "books.close.unknownChecks": "Unknown checks", "books.close.cutoff": "Period cutoff",
  "books.close.locked": "Period locked", "books.close.unlocked": "Period not locked",
  "books.close.ledgerRevision": "Posted ledger revision",
  "books.close.readinessRevision": "Readiness revision",
  "books.close.sourceRevision": "Check source revision", "books.close.openSource": "Open related page",
  "books.close.trialOpening": "Opening trial balance",
  "books.close.trialTurnover": "Trial balance turnover",
  "books.close.trialClosing": "Closing trial balance",
  "books.close.drafts": "Unposted draft journals",
  "books.close.payments": "Unreconciled confirmed payments",
  "books.close.aging": "Invoice aging review",
  "books.close.vat": "VAT source review",
  "books.close.payroll": "Payroll leave review freshness",
  "books.close.depreciation": "Unprocessed depreciation months",
  "books.close.statements": "Imported bank statement coverage",
} as const

export const booksEt: Record<keyof typeof booksEn, string> = {
  "books.setup": "Seadistamine",
  "books.search": "Otsi kirjelduse, viite või konto järgi…",
  "books.fromDate": "Alates kuupäevast", "books.toDate": "Kuni kuupäevani",
  "books.dateAndSort": "Kuupäev ja järjestus",
  "books.sort": "Järjesta kuupäeva järgi", "books.newest": "Uuemad eespool", "books.oldest": "Vanemad eespool",
  "books.rowsPerPage": "Ridu lehel", "books.range": "Kuvatakse {{start}}–{{end}}, kokku {{total}}",
  "books.dateRangeError": "Lõppkuupäev ei tohi olla alguskuupäevast varasem.",
  "books.postings": "Kande read", "books.sourceInvoice": "Ava aluseks olev arve",
  "books.sourceError": "Aluseks oleva arve laadimine ebaõnnestus.",
  "books.saveAnother": "Salvesta mustand ja loo uus",
  "books.saved": "Kande mustand on salvestatud.", "books.postedSuccess": "Kanne on kinnitatud.",
  "books.reversedSuccess": "Tagasikanne on kinnitatud.",
  "books.unsaved": "Sul on salvestamata kanne. Sellest jaotisest lahkumiseks jätka muutmist või loobu muudatustest.",
  "books.resume": "Jätka muutmist", "books.discard": "Loobu muudatustest",
  "books.leaveConfirm": "Kas loobuda salvestamata kandest ja lahkuda sellelt lehelt?",
  "books.dateError": "Sisesta kehtiv kuupäev vahemikus {{start}} kuni {{end}}.",
  "books.descriptionError": "Sisesta kirjeldus.",
  "books.accountError": "Vali aktiivne konto.",
  "books.lineAmountError": "Sisesta üks positiivne summa kas deebetisse või kreeditisse, kuni kahe komakohaga.",
  "books.dimensionError": "Vali aktiivne kulukoht või jäta kulukoht valimata.",
  "books.movement": "Perioodi käive", "books.closing": "Lõppsaldo",
  "books.filteredTotals": "Kuvatavate kontode kogusummad",
  "books.nav": "Raamatupidamine", "books.title": "Raamatupidamisraamatud",
  "books.description": "Kinnita tasakaalus kanded ja vaata perioodi kontode saldosid.",
  "books.scope": "Raamatute avamiseks vali ettevõte, projekt ja kuupäevadega periood.",
  "books.accounts": "Kontoplaan", "books.accountCode": "Konto kood", "books.accountName": "Konto nimi",
  "books.accountType": "Liik", "books.addAccount": "Lisa konto", "books.entry": "Uus kanne",
  "books.activate": "Aktiveeri", "books.deactivate": "Muuda mitteaktiivseks",
  "books.active": "Aktiivne", "books.inactive": "Mitteaktiivne",
  "books.bank": "Pank", "books.cash": "Kassa",
  "books.bankIban": "Pangakonto IBAN",
  "books.saveIban": "Salvesta IBAN",
  "books.ibanHelp": "Enne väljavõtete importimist salvesta selle pangakonto IBAN.",
  "books.useBank": "Kasuta pangakontona", "books.useCash": "Kasuta kassakontona",
  "books.descriptionField": "Kirjeldus", "books.documentNumber": "Dokumendi number (valikuline)",
  "books.date": "Kande kuupäev", "books.type": "Kande liik", "books.manual": "Käsitsi",
  "books.opening": "Algsaldo", "books.account": "Konto", "books.debit": "Deebet",
  "books.credit": "Kreedit", "books.addLine": "Lisa rida", "books.removeLine": "Eemalda rida",
  "books.save": "Salvesta mustand", "books.journals": "Raamatupidamiskanded",
  "books.edit": "Muuda mustandit", "books.cancelEdit": "Tühista muutmine",
  "books.trialSections": "Proovibilansi lähteandmed",
  "books.trialOpeningRange": "Algsaldo lähtearuande perioodi alguses.",
  "books.trialOpeningBlocked": "Lähtearuande algsaldo kuupäev on {{start}}. Seda ei saa kande kuupäeva muutes lühemasse arvestusperioodi kinnitada.",
  "books.trialTurnover": "Perioodi käive",
  "books.trialYtdNotice": "Aruande käive hõlmab ajavahemikku {{start}}–{{end}} (aasta algusest), mitte ainult valitud kvartalit. Seda mustandit ei saa lühemas perioodis kinnitada.",
  "books.trialClosing": "Lõppsaldo",
  "books.trialControlStatus": "Ainult kontrolliks",
  "books.trialClosingNotice": "Lähteandmetel põhinev kontroll, mitte lisakanne. Lõppsaldo võrdub algsaldo ja käibe summaga; uuesti kinnitamine arvestaks summad topelt.",
  "books.trialClosingDetails": "Näita lõppsaldosid kontode kaupa",
  "books.trialClosingTotals": "Aruande tasaarvestatud kogusumma: {{printed}} EUR kummalgi poolel; detailsete deebetsaldode summa: {{detail}} EUR. Üldkontode summad võivad alamkontosid tasaarvestada.",
  "books.editPosted": "Muuda kinnitatud kannet",
  "books.voidEntry": "Tühista kinnitatud kanne",
  "books.voidConfirm": "Kas tühistada kinnitatud kanne „{{description}}“? Selle mõju eemaldatakse jooksvatest saldodest ja aruannetest. Kanne ja selle versioonid säilivad ajaloos.",
  "books.voided": "Tühistatud",
  "books.voidedRevision": "Versioon {{number}} — tühistatud",
  "books.voidedHistoryNotice": "See kanne on tühistatud. Summad säilivad ajaloos ega mõjuta enam jooksvaid saldosid.",
  "books.voidedSuccess": "Kanne on tühistatud. Selle ajalugu säilib.",
  "books.voidError": "Kande tühistamine ebaõnnestus. Värskenda kannet ja kontrolli, kas see on muutunud, seotud teiste kirjetega või mõjutab lukustatud perioodi.",
  "books.entryView": "Kannete vaade",
  "books.activeEntries": "Aktiivsed kanded",
  "books.historyEntries": "Ajalugu",
  "books.noActiveEntries": "Selles vaates pole aktiivseid kandeid.",
  "books.noHistoryEntries": "Selles vaates pole storneeritud ega tühistatud kandeid.",
  "books.saveRepost": "Salvesta ja kinnita uuesti",
  "books.repostConfirm": "Kas salvestada muudatused ja asendada praegune kanne? Saldod ja jooksvad aruanded uuendatakse ning eelmine versioon säilib ajaloos.",
  "books.repostedSuccess": "Kanne on uuendatud ja uuesti kinnitatud. Eelmine versioon säilib ajaloos.",
  "books.repostError": "Kande uuesti kinnitamine ebaõnnestus. Kanne võib olla muutunud või periood lukustatud. Muudatused on alles; kontrolli enne uuesti proovimist praegust kannet.",
  "books.postedEditNotice": "Praegune kanne jääb kehtima, kuni muudatused salvestad ja uuesti kinnitad. Varasemad versioonid säilivad ajaloos.",
  "books.changeReason": "Muudatuse põhjus (valikuline)",
  "books.storno": "Storno (negatiivne käive)",
  "books.stornoHelp": "Storno korral sisesta vastukande read positiivsete summadega. Aruannetes kuvatakse negatiivsed summad vastupidistel deebeti- ja kreeditipooltel; saldod jäävad samaks.",
  "books.stornoTurnover": "Storno: negatiivne käive kuvatakse algsetel deebeti- ja kreeditipooltel. Enne kinnitamist kontrolli algdokumenti.",
  "books.history": "Ajalugu",
  "books.revision": "Versioon {{number}}",
  "books.historyError": "Kande ajaloo laadimine ebaõnnestus. Proovi uuesti.",
  "books.reversed": "Storneeritud",
  "books.createCorrected": "Loo parandatud kanne",
  "books.correctedDraftConfirm": "Kas luua sellest storneeritud kandest muudetav mustand? Algne kanne ja selle vastukanne säilivad ajaloos. Uus mustand tuleb eraldi üle vaadata ja kinnitada.",
  "books.correctedDraftCreated": "Parandatud mustand on loodud. Vaata see enne kinnitamist üle.",
  "books.correctionError": "Parandatud mustandi loomine ebaõnnestus. Värskenda kannet ja kontrolli, kas parandus on juba olemas.",
  "books.originalEntry": "Algne kanne",
  "books.viewCorrected": "Vaata parandatud kannet",
  "books.editLockedHistory": "Muutmine pole võimalik, sest see mõjutaks lukustatud või suletud arvestusperioodi.",
  "books.editDependentAsset": "See kanne on põhivara aluseks. Kasuta põhivara parandamise toimingut.",
  "books.deleteDraft": "Kustuta mustand",
  "books.accountNotRegistered": "Registreerimata",
  "books.dateReviewRequired": "Mustandi kuupäev {{date}} jääb valitud perioodist ({{start}}–{{end}}) välja. Mustandi saab salvestada, kuid enne kinnitamist tuleb algdokumendi kuupäev ja arvestusperiood üle vaadata.",
  "books.unresolvedAccounts": "Ülevaatamist vajavad kontod: {{accounts}}. Mustandi saab salvestada, kuid enne kinnitamist tuleb kontod registreerida või valida aktiivsed kontod.",
  "books.deleteDraftConfirm": "Kas kustutada kinnitamata mustand „{{description}}“? See eemaldatakse tööloendist. Algdokumendid ja toimingute ajalugu säilivad.",
  "books.deleteDraftError": "Mustandi kustutamine ebaõnnestus. Värskenda loendit ja proovi uuesti.",
  "books.draftDeleted": "Mustand kustutatud.",
  "books.deletedDraft": "Kustutatud mustand",
  "books.empty": "Selles perioodis pole veel kandeid.", "books.draft": "Mustand",
  "books.posted": "Kinnitatud", "books.post": "Kinnita kanne", "books.reverse": "Pööra kanne tagasi",
  "books.reversal": "Tagasikanne", "books.balances": "Kontode saldod",
  "books.invoice": "Arve",
  "books.payment": "Makse", "books.allocation": "Makse sidumine",
  "books.allocationReversal": "Makse seose parandamine",
  "books.creditInvoice": "Kreeditarve",
  "books.refund": "Kreeditarve tagasimakse",
  "books.payroll": "Töötasu arvestus",
  "books.wagePayment": "Töötasu makse sidumine",
  "books.advanceReceipt": "Kliendi ettemakse laekumine", "books.advanceApplication": "Kliendi ettemakse tasaarvestus",
  "books.supplierAdvance": "Tarnija ettemakse tasumine", "books.supplierApplication": "Tarnija ettemakse tasaarvestus",
  "books.advanceRefund": "Ettemakse tagastamine",
  "books.advanceCorrection": "Parandatud kliendi ettemakse tasaarvestus",
  "books.supplierAdvanceCorrection": "Parandatud tarnija ettemakse tasaarvestus",
  "books.assetCapitalization": "Põhivara soetusmaksumuse ümberliigitamine", "books.assetDepreciation": "Põhivara kulum",
  "books.assetDisposal": "Põhivara mahakandmine",
  "books.assetImpairment": "Põhivara allahindlus",
  "books.assetDepreciationCorrection": "Põhivara kulumi parandamine",
  "books.assetImpairmentReversal": "Põhivara allahindluse tühistamine",
  "books.assetDisposalCorrection": "Põhivara mahakandmise kulu ümberliigitamine",
  "books.openingDebit": "Algsaldo deebet", "books.openingCredit": "Algsaldo kreedit",
  "books.periodDebit": "Perioodi deebet", "books.periodCredit": "Perioodi kreedit",
  "books.closingDebit": "Lõppsaldo deebet", "books.closingCredit": "Lõppsaldo kreedit",
  "books.noBalances": "Kontode saldode nägemiseks kinnita kanne.",
  "books.locked": "See periood on lukustatud. Kanded on ainult vaatamiseks.",
  "books.readOnly": "Muutmiseks on vaja projekti muutmisõigust ja avatud perioodi.",
  "books.loadError": "Raamatute laadimine ebaõnnestus. Proovi uuesti.",
  "books.saveError": "Salvestamine ebaõnnestus. Kontrolli kannet ja proovi uuesti.",
  "books.deleteError": "Konto kustutamine ebaõnnestus. Proovi uuesti.",
  "books.deleteConfirm": "Kas kustutada {{name}}?",
  "books.deleteInUse": "Konto on kasutusel raamatupidamiskirjetes või seadistustes. Eemalda viited või muuda konto mitteaktiivseks.",
  "books.references": "Kasutuskohad",
  "books.referencesLimited": "Viiteid on veel. Vaata need allikad üle ja proovi uuesti.",
  "books.referencesUnavailable": "Praeguste juurdepääsuõigustega pole viidete üksikasjad kättesaadavad.",
  "books.referenceUnavailable": "Viite avamine ebaõnnestus. Kontrolli juurdepääsuõigusi ning valitud ettevõtet, projekti ja perioodi.",
  "books.balanceError": "Igal real peab olema üks summa ning deebet ja kreedit peavad võrduma.",
  "books.reversalConfirm": "Kas kinnitada selle kande tagasikanne?",
  "books.loading": "Raamatute laadimine…", "books.refresh": "Värskenda",
  "books.asset": "Vara", "books.liability": "Kohustis", "books.equity": "Omakapital",
  "books.revenue": "Tulu", "books.expense": "Kulu",
  "books.close.title": "Sulgemisvalmidus",
  "books.close.description": "Vaata valitud perioodi raamatupidamise kontrolle.",
  "books.close.disclaimer": "Ainult raamatupidamisperioodi sulgemisvalmidus. See ei ole õigusaktide ega maksunõuete hinnang ega lukusta perioodi automaatselt.",
  "books.close.loading": "Sulgemisvalmiduse laadimine…",
  "books.close.loadError": "Sulgemisvalmiduse laadimine ebaõnnestus. Proovi uuesti.",
  "books.close.ready": "Valmis raamatupidamisperioodi sulgemiseks", "books.close.needsReview": "Vajab ülevaatust",
  "books.close.unknown": "Teadmata", "books.close.passed": "Läbitud",
  "books.close.exception": "Erand", "books.close.notChecked": "Kontrollimata",
  "books.close.informational": "Teadmiseks", "books.close.required": "Kohustuslikud kontrollid",
  "books.close.information": "Teave", "books.close.otherCheck": "Täiendav kontroll",
  "books.close.count": "Arv", "books.close.exceptions": "Kohustuslikud erandid",
  "books.close.unknownChecks": "Teadmata kontrollid", "books.close.cutoff": "Perioodi lõppkuupäev",
  "books.close.locked": "Periood lukustatud", "books.close.unlocked": "Periood lukustamata",
  "books.close.ledgerRevision": "Kinnitatud pearaamatu versioon",
  "books.close.readinessRevision": "Sulgemisvalmiduse versioon",
  "books.close.sourceRevision": "Kontrolli lähteandmete versioon", "books.close.openSource": "Ava seotud leht",
  "books.close.trialOpening": "Käibeandmiku algsaldo",
  "books.close.trialTurnover": "Käibeandmiku perioodi käive",
  "books.close.trialClosing": "Käibeandmiku lõppsaldo",
  "books.close.drafts": "Kinnitamata kande mustandid",
  "books.close.payments": "Sidumata kinnitatud maksed",
  "books.close.aging": "Arvete laekumise ülevaatus",
  "books.close.vat": "Käibemaksu lähteandmete ülevaatus",
  "books.close.payroll": "Puhkuste ülevaatuse ajakohasus palgaarvestuses",
  "books.close.depreciation": "Arvestamata kulumikuud",
  "books.close.statements": "Imporditud pangaväljavõtete katvus",
}

export const booksRu: Record<keyof typeof booksEn, string> = {
  "books.setup": "Настройка",
  "books.search": "Поиск по описанию, номеру документа или счёту…",
  "books.fromDate": "С даты", "books.toDate": "По дату",
  "books.dateAndSort": "Дата и сортировка",
  "books.sort": "Сортировка по дате", "books.newest": "Сначала новые", "books.oldest": "Сначала старые",
  "books.rowsPerPage": "Строк на странице", "books.range": "Показано {{start}}–{{end}} из {{total}}",
  "books.dateRangeError": "Дата окончания не может быть раньше даты начала.",
  "books.postings": "Строки проводки", "books.sourceInvoice": "Открыть исходный счёт",
  "books.sourceError": "Не удалось загрузить исходный счёт.",
  "books.saveAnother": "Сохранить черновик и создать новый",
  "books.saved": "Черновик проводки сохранён.", "books.postedSuccess": "Запись проведена.",
  "books.reversedSuccess": "Сторнирующая запись проведена.",
  "books.unsaved": "Есть несохранённая проводка. Чтобы покинуть этот раздел, продолжите редактирование или отмените изменения.",
  "books.resume": "Продолжить редактирование", "books.discard": "Отменить изменения",
  "books.leaveConfirm": "Отменить несохранённые изменения проводки и покинуть страницу?",
  "books.dateError": "Введите корректную дату в диапазоне от {{start}} до {{end}}.",
  "books.descriptionError": "Введите описание.",
  "books.accountError": "Выберите активный счёт.",
  "books.lineAmountError": "Введите одну положительную сумму по дебету или кредиту, не более двух знаков после запятой.",
  "books.dimensionError": "Выберите активный центр затрат или оставьте поле пустым.",
  "books.movement": "Обороты за период", "books.closing": "Конечный остаток",
  "books.filteredTotals": "Итоги по отображаемым счетам",
  "books.nav": "Бухгалтерия", "books.title": "Бухгалтерские книги",
  "books.description": "Проводите сбалансированные записи и проверяйте остатки за период.",
  "books.scope": "Выберите компанию, проект и период с датами, чтобы открыть книги.",
  "books.accounts": "План счетов", "books.accountCode": "Код счёта", "books.accountName": "Название счёта",
  "books.accountType": "Тип", "books.addAccount": "Добавить счёт", "books.entry": "Новая проводка",
  "books.activate": "Активировать", "books.deactivate": "Деактивировать",
  "books.active": "Активен", "books.inactive": "Неактивен",
  "books.bank": "Банк", "books.cash": "Касса",
  "books.bankIban": "IBAN банковского счёта",
  "books.saveIban": "Сохранить IBAN",
  "books.ibanHelp": "Сохраните IBAN этого банковского счёта перед импортом выписок.",
  "books.useBank": "Использовать для банка", "books.useCash": "Использовать для кассы",
  "books.descriptionField": "Описание", "books.documentNumber": "Номер документа (необязательно)",
  "books.date": "Дата проводки", "books.type": "Тип проводки", "books.manual": "Вручную",
  "books.opening": "Начальный остаток", "books.account": "Счёт", "books.debit": "Дебет",
  "books.credit": "Кредит", "books.addLine": "Добавить строку", "books.removeLine": "Удалить строку",
  "books.save": "Сохранить черновик", "books.journals": "Журнал проводок",
  "books.edit": "Изменить черновик", "books.cancelEdit": "Отменить изменения",
  "books.trialSections": "Разделы исходной оборотно-сальдовой ведомости",
  "books.trialOpeningRange": "Начальное сальдо на начало отчётного диапазона источника.",
  "books.trialOpeningBlocked": "Начальное сальдо в источнике относится к {{start}}. Изменение даты проводки не позволяет провести его в более коротком учётном периоде.",
  "books.trialTurnover": "Обороты за период",
  "books.trialYtdNotice": "Обороты источника охватывают {{start}}–{{end}} (с начала года), а не только выбранный квартал. Черновик нельзя провести в более коротком периоде.",
  "books.trialClosing": "Конечное сальдо",
  "books.trialControlStatus": "Только для сверки",
  "books.trialClosingNotice": "Контрольные данные источника, а не дополнительная проводка. Конечное сальдо равно начальному сальдо плюс обороты; повторное проведение удвоит суммы.",
  "books.trialClosingDetails": "Показать конечные остатки по счетам",
  "books.trialClosingTotals": "Итого в отчёте со свёрнутыми остатками: {{printed}} EUR по каждой стороне; сумма детальных дебетовых остатков: {{detail}} EUR. Родительские счета могут сворачивать дочерние.",
  "books.editPosted": "Изменить проведённую запись",
  "books.voidEntry": "Аннулировать проведённую запись",
  "books.voidConfirm": "Аннулировать проведённую запись «{{description}}»? Её влияние будет исключено из текущих остатков и отчётов. Запись и её версии сохранятся в истории.",
  "books.voided": "Аннулировано",
  "books.voidedRevision": "Версия {{number}} — аннулировано",
  "books.voidedHistoryNotice": "Запись аннулирована. Эти суммы сохраняются в истории и больше не влияют на текущие остатки.",
  "books.voidedSuccess": "Запись аннулирована. Её история сохранена.",
  "books.voidError": "Не удалось аннулировать запись. Обновите её и проверьте, не изменилась ли она, нет ли связанных записей и не затрагивает ли она заблокированный период.",
  "books.entryView": "Представление записей",
  "books.activeEntries": "Активные записи",
  "books.historyEntries": "История",
  "books.noActiveEntries": "В этом представлении нет активных записей.",
  "books.noHistoryEntries": "В этом представлении нет сторнированных или аннулированных записей.",
  "books.saveRepost": "Сохранить и перепровести",
  "books.repostConfirm": "Сохранить изменения и заменить текущую проводку? Остатки и текущие отчёты будут обновлены, а предыдущая версия сохранится в истории.",
  "books.repostedSuccess": "Запись изменена и перепроведена. Предыдущая версия сохранена в истории.",
  "books.repostError": "Не удалось перепровести запись. Возможно, она изменилась или период заблокирован. Ваши изменения сохранены в форме; проверьте текущую запись перед повторной попыткой.",
  "books.postedEditNotice": "Текущая проводка действует до сохранения и перепроведения. Предыдущие версии сохраняются в истории.",
  "books.changeReason": "Причина изменения (необязательно)",
  "books.storno": "Красное сторно (отрицательные обороты)",
  "books.stornoHelp": "Для сторно введите положительные суммы обратной проводки. В отчётах суммы будут отрицательными на противоположных сторонах дебета и кредита; сальдо не изменится.",
  "books.stornoTurnover": "Красное сторно: отрицательные обороты показаны на исходных сторонах дебета и кредита. Перед проведением проверьте первичный документ.",
  "books.history": "История",
  "books.revision": "Версия {{number}}",
  "books.historyError": "Не удалось загрузить историю записи. Повторите попытку.",
  "books.reversed": "Сторнировано",
  "books.createCorrected": "Создать исправленную запись",
  "books.correctedDraftConfirm": "Создать редактируемый черновик на основе сторнированной записи? Исходная запись и её сторно сохранятся в истории. Новый черновик нужно проверить и провести отдельно.",
  "books.correctedDraftCreated": "Исправленный черновик создан. Проверьте его перед проведением.",
  "books.correctionError": "Не удалось создать исправленный черновик. Обновите запись и проверьте, не создано ли исправление ранее.",
  "books.originalEntry": "Исходная запись",
  "books.viewCorrected": "Открыть исправленную запись",
  "books.editLockedHistory": "Изменение недоступно, поскольку оно повлияет на заблокированный или закрытый учётный период.",
  "books.editDependentAsset": "Эта запись связана с основным средством. Используйте операцию исправления основного средства.",
  "books.deleteDraft": "Удалить черновик",
  "books.accountNotRegistered": "Не зарегистрирован",
  "books.dateReviewRequired": "Дата черновика {{date}} находится вне выбранного периода ({{start}}–{{end}}). Черновик можно сохранить, но перед проведением нужно проверить дату в источнике и учётный период.",
  "books.unresolvedAccounts": "Счета требуют проверки: {{accounts}}. Черновик можно сохранить, но перед проведением необходимо зарегистрировать счета или выбрать действующие.",
  "books.deleteDraftConfirm": "Удалить непроведённый черновик «{{description}}»? Он будет удалён из рабочего списка. Исходные документы и история действий сохранятся.",
  "books.deleteDraftError": "Не удалось удалить черновик. Обновите список и повторите попытку.",
  "books.draftDeleted": "Черновик удалён.",
  "books.deletedDraft": "Удалённый черновик",
  "books.empty": "За этот период проводок пока нет.", "books.draft": "Черновик",
  "books.posted": "Проведено", "books.post": "Провести запись", "books.reverse": "Сторнировать",
  "books.reversal": "Сторно", "books.balances": "Остатки по счетам",
  "books.invoice": "Счёт",
  "books.payment": "Платёж", "books.allocation": "Связь платежа",
  "books.allocationReversal": "Исправление связи платежа",
  "books.creditInvoice": "Кредит-нота",
  "books.refund": "Возврат по кредит-ноте",
  "books.payroll": "Расчёт зарплаты",
  "books.wagePayment": "Выплата зарплаты",
  "books.advanceReceipt": "Полученный аванс покупателя", "books.advanceApplication": "Зачёт аванса покупателя",
  "books.supplierAdvance": "Выплаченный аванс поставщику", "books.supplierApplication": "Зачёт аванса поставщику",
  "books.advanceRefund": "Возврат аванса",
  "books.advanceCorrection": "Исправление зачёта аванса покупателя",
  "books.supplierAdvanceCorrection": "Исправление зачёта аванса поставщику",
  "books.assetCapitalization": "Переклассификация основного средства", "books.assetDepreciation": "Амортизация основного средства",
  "books.assetDisposal": "Выбытие основного средства",
  "books.assetImpairment": "Обесценение основного средства",
  "books.assetDepreciationCorrection": "Исправление амортизации основного средства",
  "books.assetImpairmentReversal": "Сторно обесценения основного средства",
  "books.assetDisposalCorrection": "Переклассификация расхода при выбытии основного средства",
  "books.openingDebit": "Начальный дебет", "books.openingCredit": "Начальный кредит",
  "books.periodDebit": "Дебет за период", "books.periodCredit": "Кредит за период",
  "books.closingDebit": "Конечный дебет", "books.closingCredit": "Конечный кредит",
  "books.noBalances": "Проведите запись, чтобы увидеть остатки.",
  "books.locked": "Период закрыт. Проводки доступны только для просмотра.",
  "books.readOnly": "Для изменения нужны права на проект и открытый период.",
  "books.loadError": "Не удалось загрузить книги. Попробуйте ещё раз.",
  "books.saveError": "Не удалось сохранить. Проверьте проводку и повторите попытку.",
  "books.deleteError": "Не удалось удалить счёт. Повторите попытку.",
  "books.deleteConfirm": "Удалить {{name}}?",
  "books.deleteInUse": "Счёт используется в бухгалтерских записях или настройках. Удалите ссылки на него или деактивируйте счёт.",
  "books.references": "Используется в",
  "books.referencesLimited": "Есть и другие ссылки. Проверьте эти источники и повторите попытку.",
  "books.referencesUnavailable": "Сведения о ссылках недоступны с вашими текущими правами доступа.",
  "books.referenceUnavailable": "Не удалось открыть ссылку. Проверьте права доступа и выбранные компанию, проект и период.",
  "books.balanceError": "В каждой строке должна быть одна сумма, а дебет и кредит должны совпадать.",
  "books.reversalConfirm": "Провести сторно для этой записи?",
  "books.loading": "Загрузка книг…", "books.refresh": "Обновить",
  "books.asset": "Актив", "books.liability": "Обязательство", "books.equity": "Капитал",
  "books.revenue": "Доход", "books.expense": "Расход",
  "books.close.title": "Готовность к закрытию",
  "books.close.description": "Просмотрите результаты бухгалтерских проверок за выбранный период.",
  "books.close.disclaimer": "Только готовность к закрытию бухгалтерского периода. Это не оценка соблюдения требований законодательства или налогового учёта; период не блокируется автоматически.",
  "books.close.loading": "Загрузка готовности к закрытию…",
  "books.close.loadError": "Не удалось загрузить готовность к закрытию. Попробуйте ещё раз.",
  "books.close.ready": "Готово к закрытию бухгалтерского периода", "books.close.needsReview": "Требует проверки",
  "books.close.unknown": "Неизвестно", "books.close.passed": "Пройдено",
  "books.close.exception": "Отклонение", "books.close.notChecked": "Не проверено",
  "books.close.informational": "Для сведения", "books.close.required": "Обязательные проверки",
  "books.close.information": "Информация", "books.close.otherCheck": "Дополнительная проверка",
  "books.close.count": "Количество", "books.close.exceptions": "Обязательные отклонения",
  "books.close.unknownChecks": "Проверки с неизвестным результатом", "books.close.cutoff": "Конец периода",
  "books.close.locked": "Период заблокирован", "books.close.unlocked": "Период не заблокирован",
  "books.close.ledgerRevision": "Версия проведённой главной книги",
  "books.close.readinessRevision": "Версия проверки готовности",
  "books.close.sourceRevision": "Версия данных проверки", "books.close.openSource": "Открыть связанную страницу",
  "books.close.trialOpening": "Начальный остаток оборотной ведомости",
  "books.close.trialTurnover": "Обороты за период в оборотной ведомости",
  "books.close.trialClosing": "Конечный остаток оборотной ведомости",
  "books.close.drafts": "Непроведённые черновики проводок",
  "books.close.payments": "Несверенные подтверждённые платежи",
  "books.close.aging": "Проверка сроков оплаты счетов",
  "books.close.vat": "Проверка исходных данных НДС",
  "books.close.payroll": "Актуальность проверки отпусков при расчёте зарплаты",
  "books.close.depreciation": "Месяцы без начисленной амортизации",
  "books.close.statements": "Охват импортированных банковских выписок",
}
